import { GetTypeMaster, PutTypeMaster, PostTypeMaster } from '../apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../apiUtils';

export interface InspectionTypeParams {
  typeId: string;
}

const endPoint = 'inspection-type';

export const getTypeMaster = async (
  params?: InspectionTypeParams,
): Promise<GetTypeMaster> => {
  const queryParams = new URLSearchParams();

  if (params) {
    queryParams.append('typeId', params.typeId);
  }

  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'GET',
  });
  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );

  return response.data;
};

export const putTypeMaster = async (newType: PutTypeMaster): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newType),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const postTypeMaster = async (
  newType: PostTypeMaster,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(newType),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const deleteTypeMaster = async (
  params: InspectionTypeParams,
): Promise<void> => {
  const queryParams = new URLSearchParams();
  queryParams.append('typeId', params.typeId);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'DELETE',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
